{
	"termsAndConditions": {
		"title": "Termini e condizioni",
		"submitTitle": "Accetta e continua con l'Informativa sulla privacy"
	},
	"privacyPolicy": {
		"title": "Informativa sulla privacy",
		"submitTitle": "Accetta e chiudi",
		"backTitle": "Indietro"
	}
}
